var _defs, _mask, _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgIconArrowLeft(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "icon_arrow_left_svg__a",
    d: "M0 0h32v32H0z"
  }))), /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "icon_arrow_left_svg__b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#icon_arrow_left_svg__a"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#icon_arrow_left_svg__b)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M32 32H0V0h32z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: props.color,
    d: "M20.793 29l1.414-1.414L10.621 16 22.207 4.414 20.793 3l-13 13z"
  }))));
}

export default SvgIconArrowLeft;